import { MonthPicker } from "@mantine/dates";
export const monthPickerProps = MonthPicker.extend({});
